import React, { useRef, useState } from "react";

interface ImageCaptureFieldProps {
  label: string;
  onImage: (base64: string) => void;
  previewUrl?: string;
  disabled?: boolean;
}

const readFileAsDataUrl = (file: File): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });

const ImageCaptureField: React.FC<ImageCaptureFieldProps> = ({
  label,
  onImage,
  previewUrl,
  disabled,
}) => {
  const fileRef = useRef<HTMLInputElement>(null);
  const cameraRef = useRef<HTMLInputElement>(null);
  const [localPreview, setLocalPreview] = useState<string | undefined>(previewUrl);

  const handleFile = async (file?: File) => {
    if (!file || disabled) return;
    const dataUrl = await readFileAsDataUrl(file);
    setLocalPreview(dataUrl);
    onImage(dataUrl);
  };

  return (
    <div className="image-capture-field">
      <label className="image-capture-label">{label}</label>
      <div className="image-capture-actions">
        <button
          type="button"
          className="btn-secondary"
          disabled={disabled}
          onClick={() => cameraRef.current?.click()}
        >
          📷 Slikaj
        </button>
        <button
          type="button"
          className="btn-secondary"
          disabled={disabled}
          onClick={() => fileRef.current?.click()}
        >
          📁 Učitaj
        </button>
      </div>
      <input
        ref={cameraRef}
        type="file"
        accept="image/*"
        capture="environment"
        style={{ display: "none" }}
        onChange={(e) => handleFile(e.target.files?.[0])}
      />
      <input
        ref={fileRef}
        type="file"
        accept="image/*"
        style={{ display: "none" }}
        onChange={(e) => handleFile(e.target.files?.[0])}
      />
      {localPreview && (
        <img src={localPreview} alt="Preview" className="image-capture-preview" />
      )}
    </div>
  );
};

export default ImageCaptureField;
